require("./svg.js")

export function create(data, _width, _height){

    var getLineStyle = function (style, scale) {
        var arr = [];

        if (style == 0) {

        } else if (style == 1) {
            arr = [2 / scale, 1 / scale];
        } else if (style == 2) {
            arr = [1 / scale, 3 / scale];
        } else if (style == 3) {
            arr = [4 / scale, 2 / scale, 1 / scale, 2 / scale];
        } else if (style == 4) {
            arr = [4 / scale, 2 / scale, 1 / scale, 2 / scale, 1 / scale, 2 / scale];
        }

        return arr;
    }

    var getLineWidth = function (width, scale) {
        var arr = "";

        if (width == 0) {
            arr = 1 / scale;
        } else if (width == 1) {
            arr = 2 / scale;
        } else if (width == 2) {
            arr = 3 / scale;
        }

        return arr;
    }

    var getRotation = function (rotation) {
        var angle;
        if (rotation == 0) {
            angle = 0;
        } else if (rotation == 1) {
            angle = 270;
        } else if (rotation == 2) {
            angle = 180;
        } else if (rotation == 3) {
            angle = 90;
        }

        return angle;
    }
    var getFillStyle = function (hatch, fill, draw, scale) {
        var pattern = "";

        if ((hatch == 0) && (fill == 2)) {
            pattern = draw.pattern('4', '4', function(add) {
                add.path('M0 0 l4 0').fill('none').addClass('ds').stroke({
                    width: 2
                });
            })
        } else if ((hatch == 4) && (fill == 2)) {
            pattern = draw.pattern('6', '6', function(add) {
                add.path('M0 0 l0 6').fill('none').addClass('ds').stroke({
                    width: 1
                });
                add.path('M0 0 l6 0').fill('none').addClass('ds').stroke({
                    width: 1
                });

            })
        } else if ((hatch == 5) && (fill == 2)) {
            pattern = draw.pattern('6', '6', function(add) {
                add.path('M0 0 L6 6').fill('none').addClass('ds').stroke({
                    width: 0.5
                });
                add.path('M0 6 L6 0').fill('none').addClass('ds').stroke({
                    width: 0.5
                });


            })
        } else if ((hatch == 3) && (fill == 2)) {
            pattern = draw.pattern('6', '6', function(add) {

                add.path('M0 6 L6 0').fill('none').addClass('ds').stroke({
                    width: 1
                });

            })

        } else if ((hatch == 0) && (fill == 0)) {
            pattern = draw.pattern('4', '4', function(add) {

                add.rect(4, 4).move(0, 0).addClass('dfill').stroke({
                    width: 0
                });
            })
        } else if ((hatch == 2) && (fill == 2)) {
            pattern = draw.pattern('6', '6', function(add) {
                add.path('M0 0 L6 6').fill('none').addClass('ds').stroke({
                    width: 1
                });
            })
        } else if ((hatch == 1) && (fill == 2)) {
            pattern = draw.pattern('4', '4', function(add) {
                add.path('M0 0 l0 4').fill('none').addClass('ds').stroke({
                    width: 2
                });
            })
        } else if ((hatch == 0) && (fill == 1)) {
            pattern = draw.pattern('4', '4', function(add) {

            })
        }
		if(pattern) {
			 pattern.addClass("PATTERN");
			return pattern.scale(1 / scale, 1 / scale);
		} else {
			return false;
		}
       
    }

    var buildArc = function (vec) {
        var largeArc = 1;
        var rx, ry;
        if (vec.sx != -vec.ex && vec.sy != -vec.ey) {

            var rx = (vec.bbox.ex - vec.bbox.sx) / 2;
            var ry = (vec.bbox.ey - vec.bbox.sy) / 2
            var dx = vec.bbox.sx + rx
            var dy = vec.bbox.sy + ry
            var nsx = vec.sx - dx;
            var nsy = vec.sy - dy;
            var nex = vec.ex - dx;
            var ney = vec.ey - dy;
            var getQuorter = function(x, y) {
                if (x >= 0 && y > 0) {
                    return {
                        q: 1,
                        v: x
                    };
                } else if (x > 0 && y <= 0) {
                    return {
                        q: 2,
                        v: -y
                    }
                } else if (x <= 0 && y < 0) {
                    return {
                        q: 3,
                        v: -x
                    }
                } else if (x < 0 && y >= 0) {
                    return {
                        q: 4,
                        v: y
                    }
                }
            };
            var qs = getQuorter(nsx, nsy);
            var qe = getQuorter(nex, ney);
            if (qe.q < qs.q) {
                qe.q += 4
            };
            if ((qe.q - qs.q) == 1 || ((qs.q == qe.q && qe.v > qs.v) || (qs.q + 2 == qe.q && qe.v < qs.v))) {
                largeArc = 0;
            }
        }
        var a = 'M' + vec.sx + ' ' + vec.sy + ' A' + rx + ' ' + ry + ' 0 ' + largeArc + ' 0 ' + vec.ex + ' ' + vec.ey

        return 'M' + vec.sx + ' ' + vec.sy + ' A' + rx + ' ' + ry + ' 0 ' + largeArc + ' 0 ' + vec.ex + ' ' + vec.ey;
    }
    var getHeaders = function (){
        var str = "<?xml version=\"1.0\" encoding=\"utf-8\"?><!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 20010904//EN\" \"http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd\">";

        return str;
    }

    var _create = function (data, _width, _height) {
        var svgParentContainerId = 'drawing';
        //console.log("json received by the converter library:");
        //console.log(data);
        var draw = SVG(svgParentContainerId);
        //console.log('created svg drowing by the id '+draw.id().toString());
        
        
        var partCnt = data.parts.length;
        var bboxw = 0;
        var bboxh = 0;			   
        for (var partIndex = 0; partIndex<partCnt; partIndex++){
            
            
            var textOffsetx = 0;
            var textOffsety = 0;

            var x1 = data.parts[partIndex].bbox.uL.x;
            var y1 = data.parts[partIndex].bbox.uL.y;
            var x2 = data.parts[partIndex].bbox.lR.x;
            var y2 = data.parts[partIndex].bbox.lR.y;

            var bboxw = Math.max(bboxw,x2 - x1);
            var bboxh = Math.max(bboxh,y2 - y1);

            
        }
        //draw.size(w + 80, h + 80);
        draw.size(_width, _height);
        draw.viewbox(-40, -40, bboxw + 80, bboxh + 80);
        var vb = draw.viewbox();
        
        for (var partIndex = 0; partIndex<partCnt; partIndex++){
            
            
            var textOffsetx = 0;
            var textOffsety = 0;

            var x1 = data.parts[partIndex].bbox.uL.x;
            var y1 = data.parts[partIndex].bbox.uL.y;
            var x2 = data.parts[partIndex].bbox.lR.x;
            var y2 = data.parts[partIndex].bbox.lR.y;

            var w = x2 - x1;
            var h = y2 - y1;

            //draw.size(w + 80, h + 80);
            //draw.size(_width, _height);
            //draw.viewbox(-40, -40, w + 80, h + 80);
            //var vb = draw.viewbox();


            var scale = vb.zoom;
            //groups:
            var g_pins = draw.group();
            g_pins.addClass('PINS')
            var g_pin_names = draw.group();
            g_pin_names.addClass('PINS_NAMES');
            var g_pin_numbers = draw.group();
            g_pin_numbers.addClass('PINS_NUMBERS');
            var g_text = draw.group();
            g_text.addClass('TEXT');
            var g_graphic = draw.group();
            g_graphic.addClass('GRAPHIC');

            var packages = draw.group();
            packages.addClass('PACKAGES_'+data.parts[partIndex].designator);
            if (partIndex != 0){
                packages.attr('style', "visibility:hidden;");
            }
            


            packages.add(g_pins)
            packages.add(g_pin_names)
            packages.add(g_pin_numbers)
            packages.add(g_text)
            packages.add(g_graphic)



            var displayNumbers = true;

            var le = data.parts[partIndex].length;

            for (var el in data.parts[partIndex]) {

                if (el == "bbox") {


                    var boxLine = draw.rect(w, h).move(0, 0).fill("none").stroke({
                        dasharray: [3 / scale, 3 / scale],
                        width: 1 / scale
                    }).addClass('stroke nofill');

                    g_graphic.add(boxLine);

                } else if (el == "shapes") {


                    var len = data.parts[partIndex].shapes.length;

                    for (var i = 0; i < len; i++) {


                        if (data.parts[partIndex].shapes[i].type == "TEXT") {





                            var xx = data.parts[partIndex].shapes[i].bbox.uL.x;
                            var yy = data.parts[partIndex].shapes[i].bbox.uL.y;

                            var dx = data.parts[partIndex].shapes[i].bbox.lR.x - data.parts[partIndex].shapes[i].bbox.uL.x;
                            var dy = data.parts[partIndex].shapes[i].bbox.lR.y - data.parts[partIndex].shapes[i].bbox.uL.y;

                            var rotation = getRotation(data.parts[partIndex].shapes[i].rotation);

                            var t = data.parts[partIndex].shapes[i].text;
                            var tab = t.split("\r")

                            var te = "";
                            var le = tab.length;
                            for (var u = 0; u < le; u++) {
                                te += tab[u] + "\r\n";
                            }



                            var text = g_text.text(te).move(xx, yy).stroke("none").addClass("textFont");


                            text.font('family', data.parts[partIndex].shapes[i].font.name);
                            var hFont;
                            if (data.parts[partIndex].shapes[i].font.height < 0) {
                                hFont = data.parts[partIndex].shapes[i].font.height * -1;
                            } else {
                                hFont = data.parts[partIndex].shapes[i].font.height;
                            }
                            text.font('size', hFont + 'px');






                            if (data.parts[partIndex].shapes[i].font.italic == 1) {
                                var italic = "italic";
                                text.font('font-style', italic);
                            }
                            var underline;
                            if (data.parts[partIndex].shapes[i].font.underline == 1) {
                                var underline = "underline";
                                text.font('text-decoration', underline);
                            }
                            var strikeOut;
                            if (data.parts[partIndex].shapes[i].font.strikeOut == 1) {
                                var strikeOut = "line-through";
                                text.font('text-decoration', strikeOut);
                            }

                            text.font('weight', data.parts[partIndex].shapes[i].font.weight)

                            var x2s = text.rbox().x2;
                            var y2s = text.rbox().y2;
                            var h = text.bbox().h;
                            var w = text.bbox().w;
                            var dxx = x2s - xx;
                            var dyy = y2s - yy;



                            if (data.parts[partIndex].shapes[i].rotation == 0) {

                            } else if (data.parts[partIndex].shapes[i].rotation == 1) {


                                text.rotate(rotation, xx, yy + h).dmove(-w + h, h - 5);
                            } else if (data.parts[partIndex].shapes[i].rotation == 2) {

                                text.rotate(rotation, xx, yy + h).dmove(-w, h - 5);


                            } else if (data.parts[partIndex].shapes[i].rotation == 3) {

                                text.rotate(rotation, xx, yy + h).dmove(-h, -5);


                            }
                            g_text.add(text);


                        } else if (data.parts[partIndex].shapes[i].type == "PROP") {


                            if (data.parts[partIndex].shapes[i].isVisible == 1) {




                                var xx = data.parts[partIndex].shapes[i].location.x;
                                var yy = data.parts[partIndex].shapes[i].location.y;


                                var rotation = getRotation(data.parts[partIndex].shapes[i].rotation);



                                var text = draw.text(data.parts[partIndex].shapes[i].text).move(xx, yy).stroke("none").addClass("propsFont");

                                if (data.parts[partIndex].shapes[i].font != undefined){
                                    text.font('family', data.parts[partIndex].shapes[i].font.name);
                                    var hFont;
                                    if (data.parts[partIndex].shapes[i].font.height < 0) {
                                        hFont = data.parts[partIndex].shapes[i].font.height * -1;
                                    } else {
                                        hFont = data.parts[partIndex].shapes[i].font.height;
                                    }
                                    text.font('size', hFont + 'px');


                                    if (data.parts[partIndex].shapes[i].font.italic == 1) {
                                        var italic = "italic";
                                        text.font('font-style', italic);
                                    }
                                    var underline;
                                    if (data.parts[partIndex].shapes[i].font.underline == 1) {
                                        var underline = "underline";
                                        text.font('text-decoration', underline);
                                    }
                                    var strikeOut;
                                    if (data.parts[partIndex].shapes[i].font.strikeOut == 1) {
                                        var strikeOut = "line-through";
                                        text.font('text-decoration', strikeOut);
                                    }


                                    text.font('weight', data.parts[partIndex].shapes[i].font.weight);
                                }

                                var x2s = text.rbox().x2;
                                var y2s = text.rbox().y2;
                                var h = text.bbox().h;
                                var w = text.bbox().w;
                                var dxx = x2s - xx;
                                var dyy = y2s - yy;



                                if (data.parts[partIndex].shapes[i].rotation == 0) {

                                } else if (data.parts[partIndex].shapes[i].rotation == 1) {


                                    text.rotate(rotation, xx, yy + h).dmove(-w + h, h);
                                } else if (data.parts[partIndex].shapes[i].rotation == 2) {

                                    text.rotate(rotation, xx, yy + h).dmove(-w, h);


                                } else if (data.parts[partIndex].shapes[i].rotation == 3) {

                                    text.rotate(rotation, xx, yy + h).dmove(-h, 0);


                                }
                                g_text.add(text);

                            }


                        } else if (data.parts[partIndex].shapes[i].type == "LINE") {

                            var startx = data.parts[partIndex].shapes[i].start.x;
                            var starty = data.parts[partIndex].shapes[i].start.y;
                            var endx = data.parts[partIndex].shapes[i].end.x;
                            var endy = data.parts[partIndex].shapes[i].end.y;
                            var style = data.parts[partIndex].shapes[i].style;
                            var width = data.parts[partIndex].shapes[i].width;


                            var dasharray = getLineStyle(style, scale);
                            var widthline = getLineWidth(width, scale);

                            var line = draw.line(startx, starty, endx, endy).stroke({
                                dasharray: dasharray,
                                width: widthline
                            });//.addClass('stroke nofill');

                            g_graphic.add(line);

                        } else if (data.parts[partIndex].shapes[i].type == "SYMBOL") {

                            var startx = data.parts[partIndex].shapes[i].location.x;
                            var starty = data.parts[partIndex].shapes[i].location.y;

                            var lm = data.parts[partIndex].shapes[i].shapes.length;
                            for (var m = 0; m < lm; m++) {


                                if (data.parts[partIndex].shapes[i].shapes[m].type == "POLYLINE") {
                                    var les = data.parts[partIndex].shapes[i].shapes[m].point.length;
                                    var po = "";
                                    for (var k = 0; k < les; k++) {


                                        var x = startx + data.parts[partIndex].shapes[i].shapes[m].point[k].x;
                                        var y = starty + data.parts[partIndex].shapes[i].shapes[m].point[k].y
                                        po += x + "," + y;

                                        if (k + 1 < les) {
                                            po += " ";
                                        }


                                    }


                                    var dasharray = getLineStyle(data.parts[partIndex].shapes[i].shapes[m].style, scale);
                                    var widthline = getLineWidth(data.parts[partIndex].shapes[i].shapes[m].width, scale);
                                    var poly = draw.polyline(po).stroke({
                                        dasharray: dasharray,
                                        width: widthline
                                    }).addClass('stroke nofill');

                                    g_graphic.add(poly);
                                }


                            }

                        } else if (data.parts[partIndex].shapes[i].type == "BOX") {

                            var startx = data.parts[partIndex].shapes[i].bbox.uL.x;
                            var starty = data.parts[partIndex].shapes[i].bbox.uL.y;
                            var endx = data.parts[partIndex].shapes[i].bbox.lR.x;
                            var endy = data.parts[partIndex].shapes[i].bbox.lR.y;
                            var dx = endx - startx;
                            var dy = endy - starty;

                            var dasharray = getLineStyle(data.parts[partIndex].shapes[i].style, scale);
                            var widthline = getLineWidth(data.parts[partIndex].shapes[i].width, scale);

                            var pattern = getFillStyle(data.parts[partIndex].shapes[i].hatch, data.parts[partIndex].shapes[i].fill, draw, scale);



                            var box = draw.rect(dx, dy).move(startx, starty).stroke({
                                dasharray: dasharray,
                                width: widthline
                            }).addClass('stroke');
                            if (pattern) {
                                box = box.fill(pattern);
                            }

                            g_graphic.add(box);

                        } else if (data.parts[partIndex].shapes[i].type == "ELLIPSE") {


                            var startx = data.parts[partIndex].shapes[i].bbox.uL.x;
                            var starty = data.parts[partIndex].shapes[i].bbox.uL.y;
                            var endx = data.parts[partIndex].shapes[i].bbox.lR.x;
                            var endy = data.parts[partIndex].shapes[i].bbox.lR.y;
                            var rx = (endx - startx);
                            var ry = (endy - starty);
                            var cx = startx;
                            var cy = starty;

                            var dasharray = getLineStyle(data.parts[partIndex].shapes[i].style, scale);
                            var widthline = getLineWidth(data.parts[partIndex].shapes[i].width, scale);

                            var pattern = getFillStyle(data.parts[partIndex].shapes[i].hatch, data.parts[partIndex].shapes[i].fill, draw, scale);

                            var ellipse = draw.ellipse(rx, ry).move(cx, cy).fill("none").stroke({
                                dasharray: dasharray,
                                width: widthline
                            }).addClass('stroke');
                            if (pattern) {
                                ellipse = ellipse.fill(pattern);
                            }

                            g_graphic.add(ellipse);

                        } else if (data.parts[partIndex].shapes[i].type == "ARC") {

                            var startboxx = data.parts[partIndex].shapes[i].bbox.uL.x;
                            var startboxy = data.parts[partIndex].shapes[i].bbox.uL.y;
                            var endboxx = data.parts[partIndex].shapes[i].bbox.lR.x;
                            var endboxy = data.parts[partIndex].shapes[i].bbox.lR.y;



                            var startx = data.parts[partIndex].shapes[i].start.x;
                            var starty = data.parts[partIndex].shapes[i].start.y;
                            var endx = data.parts[partIndex].shapes[i].end.x;
                            var endy = data.parts[partIndex].shapes[i].end.y;

                            var radius = data.parts[partIndex].shapes[i].radius;
                            var startAngle = data.parts[partIndex].shapes[i].startartAngle;
                            var endAngle = data.parts[partIndex].shapes[i].endAngle;

                            var dasharray = getLineStyle(data.parts[partIndex].shapes[i].style, scale);
                            var widthline = getLineWidth(data.parts[partIndex].shapes[i].width, scale);

                            var vec = {
                                sx: startx,
                                sy: starty,
                                ex: endx,
                                ey: endy,
                                bbox: {
                                    sx: startboxx,
                                    sy: startboxy,
                                    ex: endboxx,
                                    ey: endboxy
                                }
                            };
                            var arc = draw.path(buildArc(vec)).stroke({
                                dasharray: dasharray,
                                width: widthline
                            }).fill("none").addClass('stroke')
                            g_graphic.add(arc);

                        } else if (data.parts[partIndex].shapes[i].type == "BEZIER") {

                            var ler = data.parts[partIndex].shapes[i].point.length;
                            var p = "M";
                            for (var j = 0; j < ler; j++) {

                                if (j == 1) {
                                    p += " C ";
                                }
                                var x = data.parts[partIndex].shapes[i].point[j].x;
                                var y = data.parts[partIndex].shapes[i].point[j].y
                                p += x + " " + y;



                                if ((j + 1 < ler) && (j != 0)) {
                                    p += ",";
                                }
                            }
                            var dasharray = getLineStyle(data.parts[partIndex].shapes[i].style, scale);
                            var widthline = getLineWidth(data.parts[partIndex].shapes[i].width, scale);

                            var bezier = draw.path(p).addClass('stroke nofill').stroke({
                                dasharray: dasharray,
                                width: widthline
                            });

                            g_graphic.add(bezier);

                        } else if (data.parts[partIndex].shapes[i].type == "POLYLINE") {


                            var les = data.parts[partIndex].shapes[i].point.length;
                            var po = "";
                            for (var k = 0; k < les; k++) {


                                var x = data.parts[partIndex].shapes[i].point[k].x;
                                var y = data.parts[partIndex].shapes[i].point[k].y
                                po += x + "," + y;

                                if (k + 1 < les) {
                                    po += " ";
                                }


                            }
                            var dasharray = getLineStyle(data.parts[partIndex].shapes[i].style, scale);
                            var widthline = getLineWidth(data.parts[partIndex].shapes[i].width, scale);

                            var polyline = draw.polyline(po).stroke({
                                width: 1 / scale
                            }).stroke({
                                dasharray: dasharray,
                                width: widthline
                            }).addClass('stroke nofill')

                            g_graphic.add(polyline);
                        } else if (data.parts[partIndex].shapes[i].type == "POLYGON") {


                            var les = data.parts[partIndex].shapes[i].point.length;
                            var pog = "";
                            for (var k = 1; k < les; k++) {


                                var x = data.parts[partIndex].shapes[i].point[k].x;
                                var y = data.parts[partIndex].shapes[i].point[k].y
                                pog += x + "," + y;

                                if (k + 1 < les) {
                                    pog += " ";
                                } else if (k == les - 1) {
                                    pog += " " + data.parts[partIndex].shapes[i].point[0].x + "," + data.parts[partIndex].shapes[i].point[0].y;

                                }


                            }

                            var dasharray = getLineStyle(data.parts[partIndex].shapes[i].style, scale);
                            var widthline = getLineWidth(data.parts[partIndex].shapes[i].width, scale);

                            var pattern = getFillStyle(data.parts[partIndex].shapes[i].hatch, data.parts[partIndex].shapes[i].fill, draw, scale);

                            var polygon = draw.polyline(pog).stroke({
                                dasharray: dasharray,
                                width: widthline
                            }).addClass("stroke");
                            if (pattern) {
                                polygon = polygon.fill(pattern);
                            }
                            g_graphic.add(polygon);

                        } else if (data.parts[partIndex].shapes[i].type == "BITMAP") {


                            var base64 = data.parts[partIndex].shapes[i].base64;
                            var sx = data.parts[partIndex].shapes[i].bbox.uL.x;
                            var sy = data.parts[partIndex].shapes[i].bbox.uL.y;
                            //var dx = data.parts[partIndex].shapes[i].size.width / scale;
                            var dx = (data.parts[partIndex].shapes[i].bbox.lR.x - data.parts[partIndex].shapes[i].bbox.uL.x) ;
                            //var dy = data.parts[partIndex].shapes[i].size.height / scale;
                            var dy = (data.parts[partIndex].shapes[i].bbox.lR.y - data.parts[partIndex].shapes[i].bbox.uL.y) ;

                            var uri = "data:;base64," + base64;


                            var bitmap = draw.image(uri, dx, dy).move(sx, sy);
                            bitmap.attr('preserveAspectRatio', "none");
                            g_graphic.add(bitmap);

                        }
                    }


                } else if (el == "pins") {


                    var lp = data.parts[partIndex].pins.length;

                    for (var i = 0; i < lp; i++) {


                        var isClock = data.parts[partIndex].pins[i].isClock;
                        var isDot = data.parts[partIndex].pins[i].isDot;
                        var isLong = data.parts[partIndex].pins[i].isLong;

                        var zeroLength = false;
                        var zeroLengthDir = "";



                        var startPointx = data.parts[partIndex].pins[i].startPoint.x;
                        var startPointy = data.parts[partIndex].pins[i].startPoint.y;

                        var hotspotx = data.parts[partIndex].pins[i].hotSpot.x;
                        var hotspoty = data.parts[partIndex].pins[i].hotSpot.y;

                        //console.log(i.toString()+": pinstart (x: "+startPointx+", y: "+startPointy+")");
                        //console.log(i.toString()+":hotspot (x: "+hotspotx+", y: "+hotspoty+")");


                        var direction = "";
                        var dotpincx;
                        var dotpincy;
                        var dotpinelem = false;
                        var textPointy = startPointy; 
                        var textPointx = startPointx; 
                        var ang = 0;
                        if ((startPointx == hotspotx) && (startPointy > hotspoty)) {
                            direction = "PN";

                            ang = 270;
                        } else if ((startPointx == hotspotx) && (startPointy < hotspoty)) {
                            direction = "PD";

                            ang = 270;
                        } else if ((startPointx > hotspotx) && (startPointy == hotspoty)) {
                            direction = "W";

                            ang = 0;
                        } else if ((startPointx < hotspotx) && (startPointy == hotspoty)) {
                            direction = "E";

                            ang = 0;
                        } else {

                            zeroLength = true;


                            ang = 0
                        }
                        var startPointx2 = startPointx;
                        var startPointy2 = startPointy;

                        if (isDot == true) {

                            if (direction == "E") {
                                dotpincx = startPointx;
                                dotpincy = startPointy - 3;
                                startPointx2 = startPointx + 6;
                                hotspotx += 6;
                                dotpinelem = true;

                                //textPointx += 5;
                            }
                            if (direction == "W") {
                                dotpincx = startPointx - 6;
                                dotpincy = startPointy - 3;
                                startPointx2 = startPointx - 6;
                                hotspotx -= 6;
                                dotpinelem = true;

                                //textPointx -= 5;
                            }
                            if (direction == "PN") {
                                dotpincx = startPointx - 3;
                                dotpincy = startPointy - 6;
                                startPointy2 = startPointy - 6;
                                hotspoty -= 6;
                                dotpinelem = true;

                                //textPointy -= 12;
                            }
                            if (direction == "PD") {
                                dotpincx = startPointx - 3;
                                dotpincy = startPointy;
                                startPointy2 = startPointy + 6;
                                hotspoty += 6;
                                dotpinelem = true;

                                //textPointy += 10;
                            }

                        }

                        if (zeroLength != true) {

                            var line = draw.line(startPointx2, startPointy2, hotspotx, hotspoty).stroke({
                                with: 1
                            }).addClass("pinstroke")

                            g_pins.add(line);


                            if (isClock == true) {
                                var aax = startPointx;
                                var aay = startPointy;
                                var bbx = startPointx;
                                var bby = startPointy;
                                var ccx = startPointx;
                                var ccy = startPointy;

                                if (direction == "W") {
                                    aax = startPointx;
                                    aay = startPointy - 4;
                                    bbx = startPointx + 4;
                                    bby = startPointy;
                                    ccx = startPointx;
                                    ccy = startPointy + 4;

                                }
                                if (direction == "E") {
                                    aax = startPointx;
                                    aay = startPointy - 4;
                                    bbx = startPointx - 4;
                                    bby = startPointy;
                                    ccx = startPointx
                                    ccy = startPointy + 4;

                                }
                                if (direction == "PN") {
                                    aax = startPointx - 4;
                                    aay = startPointy;
                                    bbx = startPointx
                                    bby = startPointy + 4;
                                    ccx = startPointx + 4;
                                    ccy = startPointy;

                                }
                                if (direction == "PD") {
                                    aax = startPointx - 4;
                                    aay = startPointy;
                                    bbx = startPointx;
                                    bby = startPointy - 4;
                                    ccx = startPointx + 4;
                                    ccy = startPointy;

                                }

                                var crossdef = "M " + aax + " " + aay + " L " + bbx + " " + bby + " L " + ccx + " " + ccy;


                                var p = draw.path(crossdef).stroke({
                                    width: 1 / scale
                                }).addClass("pinstroke nofill")

                                g_pins.add(p);
                            }
                        } else {

                            var e = draw.ellipse(8, 6).move(startPointx - 4, startPointy - 3).fill("none").stroke({
                                width: 1 / scale
                            }).addClass('pinstroke nofill');

                            g_pins.add(e);


                            var ax = startPointx - 4;
                            var ay = startPointy;
                            var bx = ax + 8;
                            var by = ay;
                            var cx = ax + 4;
                            var cy = by - 3;
                            var dx = cx;
                            var dy = by + 3;
                            var crossdef = "M " + ax + " " + ay + " L " + bx + " " + by + " M " + cx + " " + cy + " L " + dx + " " + dy + " z ";

                            var p;


                            if (startPointx == x1) {
                                p = draw.path(crossdef).stroke({
                                    width: 1 / scale
                                }).rotate(90).addClass("pinstroke nofill")
                                e.rotate(90);
                                direction = "W";


                            } else if (startPointx == x2) {
                                p = draw.path(crossdef).stroke({
                                    width: 1 / scale
                                }).rotate(90).addClass("pinstroke nofill")
                                e.rotate(90)
                                direction = "E";


                            } else if (startPointy == y1) {
                                p = draw.path(crossdef).stroke({
                                    width: 1 / scale
                                }).addClass("pinstroke nofill")
                                ang = 270;
                                direction = "PN";

                            } else if (startPointy == y2) {

                                p = draw.path(crossdef).stroke({
                                    width: 1 / scale
                                }).addClass("pinstroke nofill")

                                ang = 270;
                                direction = "PD";
                            } else {
                                p = draw.path(crossdef).stroke({
                                    width: 1 / scale
                                }).addClass("pinstroke nofill")
                            }

                            g_pins.add(p);
                        }

                        if (dotpinelem == true) {

                            var ellipse = draw.ellipse(6, 6).move(dotpincx, dotpincy).fill("none").stroke({
                                width: 1 / scale
                            }).addClass('pinstroke nofill');

                            g_pins.add(ellipse);

                        }


                        //console.log(data.parts[partIndex].pins[i].number)
                        //console.log(textPointx)
                        //console.log(textPointy)


                        var textNumbers = draw.text(data.parts[partIndex].pins[i].number).move(textPointx, textPointy).stroke("none").addClass("pinFont");
                        textNumbers.font('size', 10 + 'px');
                        g_pin_numbers.add(textNumbers);



                        var textNames = draw.text(data.parts[partIndex].pins[i].name).move(textPointx, textPointy).stroke("none").addClass("pinFont");
                        textNames.font('size', 10 + 'px');
                        g_pin_names.add(textNames);

                        if (direction == "W") {
                            var newPosx = startPointx - textNumbers.bbox().w - 7;
                            var newPosy = startPointy - textNumbers.bbox().h + 1;
                            textNumbers.move(newPosx, newPosy);

                            var newPosx = startPointx - textNames.bbox().w - 7;
                            var newPosy = startPointy - textNames.bbox().h + 1;
                            textNames.move(newPosx, newPosy);
                        }
                        if (direction == "E") {
                            var newPosx = startPointx + 7;
                            var newPosy = startPointy - textNumbers.bbox().h + 1;
                            textNumbers.move(newPosx, newPosy);

                            var newPosx = startPointx + 7;
                            var newPosy = startPointy - textNames.bbox().h + 1;
                            textNames.move(newPosx, newPosy);

                        }
                        if (direction == "PN") {

                            var newPosx = textPointx - textNumbers.bbox().h + 1;
                            var newPosy = textPointy - 7;
                            textNumbers.move(newPosx, newPosy).rotate(ang, newPosx, newPosy);

                            var newPosx = textPointx - textNames.bbox().h + 1;
                            var newPosy = textPointy - 7;
                            textNames.move(newPosx, newPosy).rotate(ang, newPosx, newPosy);



                        }
                        if (direction == "PD") {

                            var newPosx = textPointx - textNumbers.bbox().h + 1;
                            var newPosy = textPointy + 7 + textNumbers.bbox().w;
                            textNumbers.move(newPosx, newPosy).rotate(ang, newPosx, newPosy);

                            var newPosx = textPointx - textNames.bbox().h + 1;
                            var newPosy = textPointy + 7 + textNames.bbox().w;
                            textNames.move(newPosx, newPosy).rotate(ang, newPosx, newPosy);

                        }





                    }
                }
            }
            if (displayNumbers == true) {
                g_pin_names.hide();
            } else {
                g_pin_numbers.hide();
            }
            
            
        }
        
        
        var st = "<![CDATA[.PINS {  fill:none; stroke:#FF2200; }.PIN_NAMES {  fill:#FF2200; stroke:#FF2200;  font-family:Arial,Verdana,sans-serif;}.PIN_NUMBERS {  fill:#FF2200; stroke:#FF2200;  font-family:Arial,Verdana,sans-serif;}.TEXT {   fill:#3366cc; stroke:#3366cc;  font-family:Arial,Verdana,sans-serif;}.GRAPHIC {  fill:none; stroke:#3366cc; }.ds{stroke: #3366cc;}.nofill{fill: none;}.stroke{stroke: #3366cc;}.pinstroke {stroke: #FF2200;.pinFont{fill: #666;}}]]>";
        
        //('reading svg from '+draw.id().toString());
		var lastindexofdrawing = document.getElementById(svgParentContainerId).children.length - 1;
        var d = document.getElementById(svgParentContainerId).children[lastindexofdrawing];
        
        var style = document.createElement("style");
        d.appendChild(style);
        var tstyle = document.createTextNode("#*#*#");
        style.appendChild(tstyle);
        var serializer = new XMLSerializer();
        var xml = serializer.serializeToString(d);
        draw.remove();
        var xml = xml.replace("#*#*#",st);
        
        
        
        return getHeaders()+ xml;
    }
    
    //console.log("json passed to the method constructor:");
    //console.log(data);
    return _create(data, _width, _height)
}



// WEBPACK FOOTER //
// ./src/Tools/json2svg.js